import api from "@/api";
import isDataReady from "@/helpers/requests/isDataReady";
import type { LoadingType, NewFilterTypes } from "@/types";
import { computed, ref } from "vue";

type ListenerCallback = () => void | Promise<void>;

const loading = ref<LoadingType>("none");
const data = ref<NewFilterTypes[]>([]);
const listeners: ListenerCallback[] = [];

export function usePlannerCustomFilters() {
  const init = async () => {
    if (loading.value === "loaded") {
      return;
    }

    loading.value = "loading";
    data.value = await api.planner.getCustomFilters();
    loading.value = "loaded";

    for (const listener of listeners) {
      listener();
    }
  };

  init();

  const filters = computed(() => data.value);

  const isReady = () => isDataReady(loading);

  const refetch = async () => {
    loading.value = "loading";
    data.value = await api.planner.getCustomFilters();
    loading.value = "loaded";
  };

  const onLoaded = (callback: ListenerCallback) => {
    listeners.push(callback);

    if (loading.value === "loaded") {
      callback();
    }
  };

  return {
    filters,
    loading,
    refetch,
    isReady,
    onLoaded,
  };
}
